import React from 'react';
import {
  Box,
  Center,
  VStack,
  Text,
  Button,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiAlertCircle } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const ServerErrorPage = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg={bgColor}
      zIndex={9999}
    >
      <Center h="100vh">
        <VStack spacing={6} p={8} maxW="md" textAlign="center">
          <Icon as={FiAlertCircle} w={16} h={16} color="red.500" mb={4} />

          <Text fontSize="2xl" fontWeight="bold" color="gray.700">
            Oops! Something went wrong
          </Text>

          <Text fontSize="md" color="gray.600" lineHeight="tall">
            We're having trouble connecting to the server right now. Please
            check your internet connection or try again in a few minutes.
          </Text>

          <Button
            onClick={handleBack}
            colorScheme="blue"
            size="lg"
            leftIcon={<Icon as={FiAlertCircle} />}
            mt={4}
          >
            ⬅️ Back
          </Button>
        </VStack>
      </Center>
    </Box>
  );
};

export default ServerErrorPage;
